import React, { PropsWithChildren } from 'react';
import { useSearch } from 'new/elements/SearchableProvider/SearchableProvider';

export const SearchInjector = (props: PropsWithChildren<any>) => {
  const { search } = useSearch();
  const { children } = props;
  return React.cloneElement(children, { search });
};
